import Iframe from 'react-iframe';

import { Roles } from '~/types/types';

export const SecrecyRoles: Readonly<Roles[]> = [Roles.Sekretess];

export default function ExposePage(props: any) {
  return (
    <>
      <Iframe
        url="/expose/Expose?request=new&name=all&urlid=1234"
        width="100%"
        height="600px"
        id=""
        className=""
        display="block"
        position="relative"
      />
    </>
  );
}
